const TICKER = [
  "本周汇总 48 条已归档 · 2026.09.02 - 09.08",
  "近期盘点：三季度 12 起事件复盘",
  "本月黑料新近合集已更新至第 36 期",
  "时间线补课：回到 09 月第一周",
  "热度总榜刷新 · 榜首单日阅读破 300 万",
  "题材分栏新增「综艺现场」专区",
];

const TOP_RAPID = [
  { tag: "圈内", title: "顶流男团成员深夜被拍，恋情传闻登顶热一", heat: "312w", rank: 1 },
  { tag: "商界", title: "新锐消费品牌创始人退出董事会，内部信流出", heat: "276w", rank: 2 },
  { tag: "综艺", title: "国民级综艺录制现场生图流出，剪辑引争议", heat: "241w", rank: 3 },
];

export default function Hero() {
  return (
    <section id="top" className="relative w-full">
      {/* 大主视觉压顶 */}
      <div className="relative w-full h-[640px] md:h-[720px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20editorial%20press%20conference%20scene%2C%20silhouette%20of%20celebrities%20walking%20on%20red%20carpet%20under%20harsh%20camera%20flashlights%20from%20reporters%2C%20dramatic%20backlit%20bokeh%2C%20deep%20crimson%20and%20amber%20accent%20lighting%20against%20near%20black%20background%2C%20cinematic%20documentary%20photography%2C%20grainy%20film%20texture%2C%20high%20contrast%2C%20mysterious%20anonymous%20atmosphere&width=2000&height=1100&seq=hero-press-2026&orientation=landscape"
          alt="最新黑料本周汇总主视觉"
          title="最新黑料本周汇总近期盘点主视觉"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-background-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/20 to-transparent" />
      </div>

      {/* 文案层 */}
      <div className="relative z-10 -mt-[640px] md:-mt-[720px] flex flex-col justify-end pb-6 min-h-[640px] md:min-h-[720px]">
        <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
          <div className="max-w-[720px] text-background-50">
            <div className="inline-flex items-center gap-2 rounded-full bg-background-50/12 backdrop-blur border border-background-50/25 px-3 py-1 text-[13px]">
              <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse-dot" />
              <span className="tracking-wide">本周汇总 · 近期盘点 · 本月黑料 已整理成档</span>
            </div>
            <h1 className="mt-5 font-heading text-[40px] md:text-[64px] leading-[1.06] font-black tracking-tight">
              本周的大瓜，
              <br className="hidden md:block" />
              <span className="text-accent-300">一次看全。</span>
            </h1>
            <p className="mt-5 text-[15px] md:text-[17px] leading-relaxed text-background-100/90 max-w-[560px]">
              最新黑料把近 7 天散落在各平台的新近事件收拢进同一条时间线——不做二次造谣，只做索引、盘点与归档。补课不漏瓜，回看有脉络。
            </p>
            <div className="mt-7 flex flex-col sm:flex-row gap-3">
              <a
                href="#weekly"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-[15px] font-bold text-background-50 hover:bg-primary-600 transition-colors"
              >
                查看本周汇总
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="#timeline"
                className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-background-50/12 border border-background-50/30 px-6 py-3 text-[15px] font-semibold text-background-50 backdrop-blur hover:bg-background-50/20 transition-colors"
              >
                时间线补课
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 浮动速览卡 */}
      <div className="relative z-10 mx-auto w-full max-w-[1240px] px-4 md:px-6 -mt-24 md:-mt-28">
        <div className="grid grid-cols-1 md:grid-cols-3 rounded-xl overflow-hidden border border-background-200 bg-background-50 shadow-none">
          {TOP_RAPID.map((t) => (
            <a
              key={t.title}
              href="#recap"
              className="group flex items-center gap-4 p-5 border-b md:border-b-0 md:border-r border-background-200 last:border-0 hover:bg-background-100 transition-colors"
            >
              <span className="font-heading text-[34px] leading-none font-black text-primary-200 group-hover:text-primary-500 transition-colors w-9 shrink-0 text-center">
                {t.rank}
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2 text-[12px] mb-1">
                  <span className="rounded-full bg-secondary-100 text-secondary-800 px-2 py-0.5">{t.tag}</span>
                  <span className="text-foreground-400">热度 {t.heat}</span>
                </div>
                <p className="text-[14px] leading-snug text-foreground-900 line-clamp-2 group-hover:text-primary-700 transition-colors">
                  {t.title}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* 滚动头条 */}
      <div className="relative z-10 mt-6 border-t border-b border-background-200 bg-background-50 overflow-hidden">
        <div className="flex">
          <div className="shrink-0 z-10 bg-primary-500 text-background-50 flex items-center gap-2 px-4 md:px-5 text-sm font-bold whitespace-nowrap">
            <i className="ri-megaphone-line w-4 h-4 flex items-center justify-center" />
            快讯
          </div>
          <div className="relative flex-1 overflow-hidden flex items-center">
            <div className="flex whitespace-nowrap animate-marquee">
              {[...TICKER, ...TICKER].map((item, idx) => (
                <span key={idx} className="px-8 text-[13.5px] text-foreground-700">
                  <span className="mx-2 text-primary-400">·</span> {item}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}